import { defaultCurrencyInfo } from 'shared/constants/currencies';

export default [
  { type: 'rent', enabled: true, price: defaultCurrencyInfo.rent.default, period: 72 },
  { type: 'sale', enabled: false, price: defaultCurrencyInfo.sale.default },
];



// WEBPACK FOOTER //
// ./src/shared/constants/video-deal-info.js